import React from 'react';
import ActivityLoader from '../../components/Common/ActivityLoader';
import Pagination from '../../components/Common/Pagination';
import { numberFormat } from '../../util/araknerdlib';

const SalesBreakdownTable = ({
  rows,
  transactions,
  metaData,
  setCurrentPage,
  currency,
  formatCount,
  styles,
}) => {
  const StatusPill = ({ status }) => {
    const s = (status || '').toLowerCase();
    const map = {
      used:    { bg: 'rgba(16,185,129,0.15)', fg: '#34d399', label: 'Used' },
      unused:  { bg: 'rgba(148,163,184,0.12)', fg: '#cbd5e1', label: 'Unused' },
      expired: { bg: 'rgba(245,158,11,0.15)', fg: '#fbbf24', label: 'Expired' },
      revoked: { bg: 'rgba(239,68,68,0.15)', fg: '#f87171', label: 'Revoked' },
      refunded:{ bg: 'rgba(59,130,246,0.15)', fg: '#93c5fd', label: 'Refunded' },
    };
    const c = map[s] || { bg: 'rgba(99,102,241,0.15)', fg: '#a5b4fc', label: status || '—' };
    return (
      <span style={{ ...styles.badge, background: c.bg, color: c.fg }}>
        {c.label}
      </span>
    );
  };

  const SourceBadge = ({ source }) => {
    const s = (source || '').toLowerCase();
    const isMomo = s === 'momo';
    return (
      <span
        style={{
          ...styles.badge,
          background: isMomo ? 'rgba(14,165,233,0.15)' : 'rgba(168,85,247,0.15)',
          color: isMomo ? '#38bdf8' : '#d8b4fe',
          whiteSpace: 'nowrap',
        }}
      >
        {isMomo ? 'Mobile Money' : (source || 'Manual')}
      </span>
    );
  };

  return (
    <div className="card custom-card" style={styles.softCard}>
      <div className="card-body">
        <div className="d-flex align-items-center mb-3">
          <div>
            <h6 className="card-title mb-1">Sales Breakdown</h6>
            <p className="text-muted tx-12 mb-0">
              Voucher-level transactions filtered by first use
            </p>
          </div>
          <div className="ml-auto text-right">
            <div className="text-muted small">Showing</div>
            <div className="h6 mb-0">
              {metaData?.total ?? rows.length} record(s)
            </div>
          </div>
        </div>

        {!transactions && <ActivityLoader />}

        <div className="table-responsive overflow-auto" style={{maxHeight: '400px'}}>
          <table className="table table-hover tx-13 mb-0">
            <thead>
              <tr>
                <th>Code</th>
                <th>Plan</th>
                <th>Source</th>
                <th>Status</th>
                <th className="text-right">{currency}</th>
                <th className="text-right">Usage</th>
                <th>MSISDN</th>
                <th>Created By</th>
                <th>Created At</th>
                <th>First Used</th>
                <th>Last Used</th>
                <th>Expires</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td className="font-weight-semibold">
                    {row.code || row.voucher_code}
                  </td>
                  <td>{row.plan_name || row.plan_id || '—'}</td>
                  <td><SourceBadge source={row.source} /></td>
                  <td><StatusPill status={row.status} /></td>
                  <td className="text-right">{numberFormat(row.amount)}</td>
                  <td className="text-right">{formatCount(row.usage_count)}</td>
                  <td>{row.msisdn || '—'}</td>
                  <td>{row.created_by_name || row.created_by || '—'}</td>
                  <td>{row.created_at || '—'}</td>
                  <td>{row.first_used_at || '—'}</td>
                  <td>{row.last_used_at || '—'}</td>
                  <td>{row.expires_at || '—'}</td>
                </tr>
              ))}

              {transactions === '404' && (
                <tr>
                  <td colSpan="13" className="text-center text-muted py-4">
                    No sales found for the selected filters.
                  </td>
                </tr>
              )}

              {!rows.length && transactions && transactions !== '404' && (
                <tr>
                  <td colSpan="13" className="text-center text-muted py-4">
                    Nothing to show yet. Try expanding your date range.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {metaData && (
          <div className="card-footer d-flex justify-content-between align-items-center">
            <div className="text-muted small">
              Showing {metaData.total} record(s)
            </div>
            <Pagination
              metaData={metaData}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SalesBreakdownTable;
